import React, { useEffect, useState } from 'react';
import './UsersTable.css';

import Edit from '../../Assets/Icons/Edit.svg'
import Delete from '../../Assets/Icons/Delete.svg'
import { supabase } from '../../supabase';

const UsersTable = () => {

    const [users, setUsers] = useState([]);

    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [selectedUser, setSelectedUser] = useState(null);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [email, setEmail] = useState('');
    const [status, setStatus] = useState('');

    const getUsers = async () => {
        const res = await supabase.from("users").select('*');
        if (res.data) {
            setUsers(res.data);
        }
    };

    useEffect(() => {
        getUsers();
    }, [])

    const handleDeleteUser = async (id) => {
        if (window.confirm("CRITICAL WARNING:\nDeleting this user profile will instantly remove all associated booking slots due to data integrity constraints. Proceed?")) {
            const { error } = await supabase
                .from('users')
                .delete()
                .eq('id', id);

            if (error) {
                console.error("Deletion execution intercept:", error);
                alert("Failed to purge user entry structure.");
            } else {
                getUsers();
            }
        }
    };

    const handleOpenEdit = (user) => {
        setSelectedUser(user);
        setFirstName(user.first_name);
        setLastName(user.last_name);
        setEmail(user.email);
        setStatus(user.status || 'Active');
        setIsEditModalOpen(true);
    };

    const handleUpdateUser = async (e) => {
        e.preventDefault();

        const { error } = await supabase
            .from('users')
            .update({
                first_name: firstName,
                last_name: lastName,
                email: email,
                status: status
            })
            .eq('id', selectedUser.id);

        if (error) {
            console.error("Mutation failed payload routing:", error);
            alert("Failed to update database schema profile: " + error.message);
        } else {
            setIsEditModalOpen(false);
            setSelectedUser(null);
            getUsers();
        }
    };


    // const dummyUsers = [
    //     { 
    //         id: 1, 
    //         name: 'Karim Ahmed', 
    //         location: 'Cairo, Egypt', 
    //         email: 'k.ahmed@electravolt.eg', 
    //         company: 'ElectraVolt Egypt', 
    //         refId: 'KV-2024-9182', 
    //         status: 'CHECKED IN'
    //     },
    //     { 
    //         id: 2, 
    //         name: 'Sarah Jenkins', 
    //         location: 'London, UK', 
    //         email: 's.jenkins@gridworks.co', 
    //         company: 'Gridworks International', 
    //         refId: 'KV-2024-0041', 
    //         status: 'REGISTERED'
    //     },
    //     { 
    //         id: 3, 
    //         name: 'Markus Weber', 
    //         location: 'Berlin, Germany', 
    //         email: 'm.weber@auto-link.de', 
    //         company: 'AutoLink GmbH', 
    //         refId: 'KV-2024-5521', 
    //         status: 'ABSENT'
    //     },
    //     { 
    //         id: 4, 
    //         name: 'Omar Hassan', 
    //         location: 'Giza, Egypt', 
    //         email: 'o.hassan@kinetic.io', 
    //         company: 'Kinetic Solar', 
    //         refId: 'KV-2024-3329', 
    //         status: 'CHECKED IN'
    //     },
    // ];

    return (
        <div className="TableContainer">
            <table className="CustomTable">
                <thead>
                    <tr>
                        <th>NAME</th>
                        <th>EMAIL ADDRESS</th>
                        <th>REF ID</th>
                        <th>STATUS</th>
                        <th>ACTIONS</th>
                    </tr>
                </thead>
                <tbody>
                    {users.map((user) => (
                        <tr key={user.id}>
                            <td className="UserInfoCell">
                                <div>
                                    <p className="BoldText">{user.first_name + ' ' + user.last_name}</p>
                                </div>
                            </td>
                            <td className="SubText">{user.email}</td>
                            <td className="RefIdText">{user.id}</td>
                            <td>
                                <span className={user.status}>
                                    {user.status}
                                </span>
                            </td>
                            <td className='ActionBtns'>
                                                                <button className='EditBtn' onClick={() => handleOpenEdit(user)}>
                                                                    <img src={Edit} alt="" />
                                                                </button>
                            
                                                                <button className='EditBtn' onClick={() => handleDeleteUser(user.id)}>
                                                                    <img src={Delete} alt="" />
                                                                </button>
                                                        </td>
                        </tr>
                    ))}
                </tbody>
            </table>

            {isEditModalOpen && (
                <div className="BookingModalOverlay">
                    <div className="BookingModalContent">
                        <h3>Update Personnel Profile</h3>
                        <p className="ModalAttendeeSub">Editing Record: <br/><span style={{fontFamily: 'monospace', fontSize: '11px'}}>{selectedUser?.id}</span></p>
                        
                        <form onSubmit={handleUpdateUser}>
                            <div className="FormGroup">
                                <label>First Name</label>
                                <input 
                                    type="text" 
                                    value={firstName} 
                                    onChange={(e) => setFirstName(e.target.value)} 
                                    required 
                                />
                            </div>

                            <div className="FormGroup">
                                <label>Last Name</label>
                                <input 
                                    type="text" 
                                    value={lastName} 
                                    onChange={(e) => setLastName(e.target.value)} 
                                    required 
                                />
                            </div>

                            <div className="FormGroup">
                                <label>Email Coordinates</label>
                                <input 
                                    type="email" 
                                    value={email} 
                                    onChange={(e) => setEmail(e.target.value)} 
                                    required 
                                />
                            </div>

                            <div className="FormGroup">
                                <label>Operational Status</label>
                                <select 
                                    value={status} 
                                    onChange={(e) => setStatus(e.target.value)}
                                >
                                    <option value="Active">Active</option>
                                    <option value="Pending">Pending</option>
                                    <option value="Suspended">Suspended</option>
                                </select>
                            </div>

                            <div className="ModalActions">
                                <button type="button" className="CancelBtn" onClick={() => setIsEditModalOpen(false)}>
                                    Cancel
                                </button>
                                <button type="submit" className="SaveBtn">
                                    Commit Overrides
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}
        </div>
    );
};

export default UsersTable;